// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react'
import { Pane, Text, Toast } from '@leverege/ui-elements'
import { Attributes } from '@leverege/ui-attributes'
import { getOcrMatchStatusPillVariant, getToleranceStatusPillVariant } from '../Util'
import PlyLayerEditor from './PlyLayerEditor'

import S from '../PlyLayerShopFloor.css'

export default function PlyLayer( props ) {
  const { plyLayer, plyDelegate, locationId, shellId, subAssemblyJobId, userInfo, permissions, isNextSA } = props
  const [ showToleranceEditor, setShowToleranceEditor ] = useState( false )
  const [ showLabelEditor, setShowLabelEditor ] = useState( false )
  const currentToleranceStatus = Attributes.get( 'plyLayer.placement.toleranceStatus', plyLayer )
  const currentOcrMatchStatus = Attributes.get( 'plyLayer.ocr.matchStatus', plyLayer )
  const { canToleranceOverride, canOcrOverride } = permissions

  let currentToleranceStatusValue
  if ( currentToleranceStatus === 'unverified' || currentToleranceStatus === 'craneBlockage' ) {
    currentToleranceStatusValue = 'Crane'
  } else if ( currentToleranceStatus === 'withinTolerance' || currentToleranceStatus === 'notWithinTolerance' ) {
    currentToleranceStatusValue = 'Tolerance'
  } else if ( !currentToleranceStatus || currentToleranceStatus === 'inProgress' ) {
    currentToleranceStatusValue = '\u00A0'
  } else {
    currentToleranceStatusValue = 'Unverified'
  }

  let currentOcrMatchStatusValue
  if ( currentOcrMatchStatus === 'unverified' || currentOcrMatchStatus === 'craneBlockage' ) {
    currentOcrMatchStatusValue = 'Crane'
  } else if ( currentOcrMatchStatus === 'true' ) {
    currentOcrMatchStatusValue = 'Label'
  } else if ( !currentOcrMatchStatus || currentOcrMatchStatus === 'inProgress' ) {
    currentOcrMatchStatusValue = '\u00A0'
  } else {
    currentOcrMatchStatusValue = 'Unverified'
  }

  const toleranceCursorStyle = currentToleranceStatus !== 'withinTolerance' ? { cursor : 'pointer' } : {}
  const ocrCursorStyle = currentOcrMatchStatus !== 'true' ? { cursor : 'pointer' } : {}

  const handleToleranceClick = () => {
    if ( currentToleranceStatus !== 'withinTolerance' ) {
      if ( canToleranceOverride ) {
        setShowToleranceEditor( true )
      } else {
        Toast.error( 'Permission denied to override the tolerance status' )
      }
    }
  }

  const handleLabelClick = () => {
    if ( currentOcrMatchStatus !== 'true' ) {
      if ( canOcrOverride ) {
        setShowLabelEditor( true )
      } else {
        Toast.error( 'Permission denied to override the label status' )
      }
    }
  }

  return (
    <Pane variant='mobilePaceCardArea' className={S.plyLayer}>
      <div className={S.plyLayerGrid}>
        <Text variant='mobilePaceCardHeader'>
          {Attributes.get( 'name', plyLayer )}
        </Text>
        <div className={S.pillsContainer}>
          {currentToleranceStatusValue && (
            <Text 
              variant={getToleranceStatusPillVariant( currentToleranceStatus )}
              className={S.statusPill}
              onClick={handleToleranceClick}
              style={toleranceCursorStyle}>
              {currentToleranceStatusValue}
            </Text>
          )}
          {currentOcrMatchStatusValue && (
            <Text 
              variant={getOcrMatchStatusPillVariant( currentOcrMatchStatus )}
              className={S.statusPill}
              onClick={handleLabelClick}
              style={ocrCursorStyle}>
              {currentOcrMatchStatusValue}
            </Text>
          )}
        </div>
      </div>

      { showToleranceEditor && (
        <PlyLayerEditor
          type="Tolerance"
          onClose={() => setShowToleranceEditor( false )}
          plyLayer={plyLayer}
          options={[
            'Crane Blockage',
            'No Issue Identified',
            'Other'
          ]}
          plyDelegate={plyDelegate}
          locationId={locationId}
          shellId={shellId}
          subAssemblyJobId={subAssemblyJobId}
          userInfo={userInfo}
          isNextSA={isNextSA}/>
      ) }

      { showLabelEditor && (
        <PlyLayerEditor
          type="Label"
          onClose={() => setShowLabelEditor( false )}
          plyLayer={plyLayer}
          options={[
            'No Label',
            'Smudged Label',
            'Hand Written',
            'No Issue Identified',
            'Other'
          ]}
          plyDelegate={plyDelegate}
          locationId={locationId}
          shellId={shellId}
          subAssemblyJobId={subAssemblyJobId}
          userInfo={userInfo}
          isNextSA={isNextSA}/>
      ) }
    </Pane>
  )
}
